import React from 'react';
import { Checkbox } from '@heroui/react';
import { IDataField } from '../../../types/reportsTypes';

interface CheckboxGroupProps {
	fields: IDataField[];
	onChange: (updatedFields: IDataField[]) => void;
	category?: string;
}

const CheckboxGroup: React.FC<CheckboxGroupProps> = ({ fields, onChange, category }) => {
	const fieldsToShow = category ? fields.filter((field) => field.category === category) : fields;

	const handleCheckboxChange = (id: string) => {
		const updatedFields = fields.map((field) => (field.id === id ? { ...field, selected: !field.selected } : field));
		onChange(updatedFields);
	};

	const handleSelectAll = () => {
		const allSelected = fieldsToShow.every((field) => field.selected);
		const updatedFields = fields.map((field) => {
			if (category && field.category === category) {
				return { ...field, selected: !allSelected };
			} else if (!category) {
				return { ...field, selected: !allSelected };
			}
			return field;
		});
		onChange(updatedFields);
	};

	const isAllSelected = fieldsToShow.length > 0 && fieldsToShow.every((field) => field.selected);
	const isIndeterminate = fieldsToShow.some((field) => field.selected) && !isAllSelected;

	return (
		<div className="flex flex-col">
			{fieldsToShow.length > 0 && (
				<Checkbox
					isSelected={isAllSelected}
					isIndeterminate={isIndeterminate}
					onValueChange={handleSelectAll}
					className="flex items-center font-medium border-b border-gray-200 pb-1 mb-2"
					size="sm"
				>
					Select All
				</Checkbox>
			)}
			{fieldsToShow.map((field, index) => (
				<Checkbox
					key={index}
					isSelected={field.selected}
					onValueChange={() => handleCheckboxChange(field.id)}
					className="flex items-center ml-4 mb-0"
					size="sm"
				>
					{field.label}
				</Checkbox>
			))}
		</div>
	);
};

export default CheckboxGroup;
